import React from 'react';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import HomePage from './pages/HomePage';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import DocumentUpload from './pages/flow/Documentupload';
import Verif from './pages/flow/Verif';
import Report from './pages/flow/report';
import DocumentGeneratorPage from './pages/generate/DocumentGeneratorPage';
import DocumentHandover from './pages/flow/DocumentHandover';
import AnalysisPage from './pages/analysis/AnalysisPage';
import SignatureConfirmPage from './pages/signature/SignatureConfirmPage';
import SignatureDashboard from './pages/signature/SignatureDashboard';
import SignaturePositionPage from './pages/signature/SignaturePositionPage';
import PolicyDetailPage from './pages/analysis/PolicyDetailPage';
import AIChatPage from './pages/ai/AIChatPage';
import PDFExtractPage from './pages/tools/PDFExtractPage';
import ApprovedPolicyPage from './pages/analysis/ApprovedPolicyPage';
import MainLayout from './components/layout/MainLayout';
import { AppProvider } from './contexts/AppContext';
import UnderwriterHomePage from './pages/underwriter/UnderwriterHomePage';
import PolicyReviewPage from './pages/underwriter/PolicyReviewPage';
import PolicyReviewDetailPage from './pages/underwriter/PolicyReviewDetailPage';
import DocumentPreviewPage from './pages/generate/DocumentPreviewPage';
import ApprovedPolicyDetailPage from './pages/underwriter/ApprovedPolicyDetailPage';
import UwstatisticsPage from './pages/data-statistics/UwstatisticsPage';
import BrokerQualityDashboard from './pages/data-statistics/BrokerQualityDashboard';
import GeneralSettingsPage from './pages/settings/GeneralSettingsPage';
import UserManagementPage from './pages/settings/UserManagementPage';
import ApprovedPolicyListPage from './pages/underwriter/ApprovedPolicyListPage';
import UploadTypePage from './pages/flow/UploadTypePage';
import BranchPerformanceDashboard from './pages/data-statistics/BranchPerformanceDashboard';
import BrokerPerformanceDashboard from './pages/data-statistics/BrokerPerformanceDashboard';

const theme = createTheme({
  palette: {
    primary: {
      main: '#1976d2',
    },
    secondary: {
      main: '#dc004e',
    },
  },
});

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <AppProvider>
        <Router>
          <Routes>
            {/* PDF 预览页面 - 独立路由，不使用 MainLayout */}
            <Route path="/generate/document-preview/:id" element={<DocumentPreviewPage />} />
            <Route path="/underwriter/document-preview/:id" element={<DocumentPreviewPage />} />
            <Route path="/analysis/document-preview/:id" element={<DocumentPreviewPage />} />
            
            {/* 使用 MainLayout 的路由 */}
            <Route element={<MainLayout />}>
              <Route path="/" element={<HomePage />} />
              <Route path="/upload-type" element={<UploadTypePage />} />
              <Route path="/document-upload" element={<DocumentUpload />} />
              <Route path="/verify" element={<Verif />} />
              <Route path="/report" element={<Report />} />
              <Route path="/document-select" element={<DocumentGeneratorPage />} />
              
              {/* 分析模块 */}
              <Route path="/analysis" element={<AnalysisPage />} />
              <Route path="/analysis/policy-review/:id" element={<PolicyDetailPage />} />
              <Route path="/analysis/approved-policy/:id" element={<ApprovedPolicyPage />} />
              <Route path="/analysis/document-preview/:id" element={<DocumentPreviewPage />} />
              <Route path="/signature" element={<SignatureDashboard />} />
              <Route path="/signature-confirm" element={<SignatureConfirmPage />} />
              <Route path="/signature-position" element={<SignaturePositionPage />} />
              <Route path="/ai-chat" element={<AIChatPage />} />
              <Route path="/tools/pdf-extract" element={<PDFExtractPage />} />
              <Route path="/underwriter" element={<UnderwriterHomePage />} />
              <Route path="/underwriter/policy-review" element={<PolicyReviewPage />} />
              <Route path="/underwriter/policy-review/:id" element={<PolicyReviewDetailPage />} />
              <Route path="/underwriter/approved" element={<ApprovedPolicyListPage />} />
              <Route path="/underwriter/approved/:id" element={<ApprovedPolicyDetailPage />} />
              <Route path="/underwriter-statistics" element={<UwstatisticsPage />} />
              <Route path="/broker-quality" element={<BrokerQualityDashboard />} />
              <Route path="/settings/general" element={<GeneralSettingsPage />} />
              <Route path="/settings/users" element={<UserManagementPage />} />
              <Route path="/handover" element={<DocumentHandover />} />
              <Route path="/upload-type" element={<UploadTypePage />} />
              <Route path="/document-upload" element={<DocumentUpload />} />
              <Route path="/branch-manager/performance" element={<BranchPerformanceDashboard />} />
              <Route path="/broker/performance" element={<BrokerPerformanceDashboard />} />
            </Route>
          </Routes>
        </Router>
      </AppProvider>
    </ThemeProvider>
  );
}

export default App; 